import type {JobVariablesAction} from 'src/action-creators/job-variables';
import type {JobVariable, JobVariableValues} from 'src/types/job-variables';

import {
  RECEIVE_JOB_VARIABLES,
  RECEIVE_JOB_VARIABLE_VALUES,
} from 'src/action-creators/job-variables';


export type State = {
  variables: JobVariable[];
  variableValues: JobVariableValues;
};

const initialState = {
  variables: [],
  variableValues: {},
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly variables: readonly []; readonly variableValues: {}; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: JobVariablesAction,
): State => {
  switch (action.type) {
    case RECEIVE_JOB_VARIABLES: {
      // @ts-expect-error - TS2322 - Type '{ variables: JobVariable[]; variableValues?: JobVariableValues | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        variables: action.payload,
      };
    }
    case RECEIVE_JOB_VARIABLE_VALUES: {
      // @ts-expect-error - TS2322 - Type '{ variableValues: JobVariableValues; variables?: JobVariable[] | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        variableValues: action.payload,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
